import ApiClient from '../../services/ApiClient';

// Action Types
const GET_ABOUT_US_PAGE_START = 'GET_ABOUT_US_PAGE_START';
const GET_ABOUT_US_PAGE_SUCCESS = 'GET_ABOUT_US_PAGE_SUCCESS';
const GET_ABOUT_US_PAGE_FAILED = 'GET_ABOUT_US_PAGE_FAILED';
const GET_ABOUT_US_PAGE_RESET = 'GET_ABOUT_US_PAGE_RESET';

const UPDATE_ABOUT_US_PAGE_START = 'UPDATE_ABOUT_US_PAGE_START';
const UPDATE_ABOUT_US_PAGE_SUCCESS = 'UPDATE_ABOUT_US_PAGE_SUCCESS';
const UPDATE_ABOUT_US_PAGE_FAILED = 'UPDATE_ABOUT_US_PAGE_FAILED';
const UPDATE_ABOUT_US_PAGE_RESET = 'UPDATE_ABOUT_US_PAGE_RESET';

const GET_PARTNER_LOGOS_START = 'GET_PARTNER_LOGOS_START';
const GET_PARTNER_LOGOS_SUCCESS = 'GET_PARTNER_LOGOS_SUCCESS';
const GET_PARTNER_LOGOS_FAILED = 'GET_PARTNER_LOGOS_FAILED';
const GET_PARTNER_LOGOS_RESET = 'GET_PARTNER_LOGOS_RESET';

const GET_ONE_PARTNER_LOGO_START = 'GET_ONE_PARTNER_LOGO_START';
const GET_ONE_PARTNER_LOGO_SUCCESS = 'GET_ONE_PARTNER_LOGO_SUCCESS';
const GET_ONE_PARTNER_LOGO_FAILED = 'GET_ONE_PARTNER_LOGO_FAILED';
const GET_ONE_PARTNER_LOGO_RESET = 'GET_ONE_PARTNER_LOGO_RESET';

const CREATE_PARTNER_LOGO_START = 'CREATE_PARTNER_LOGO_START';
const CREATE_PARTNER_LOGO_SUCCESS = 'CREATE_PARTNER_LOGO_SUCCESS';
const CREATE_PARTNER_LOGO_FAILED = 'CREATE_PARTNER_LOGO_FAILED';
const CREATE_PARTNER_LOGO_RESET = 'CREATE_PARTNER_LOGO_RESET';

const UPDATE_PARTNER_LOGO_START = 'UPDATE_PARTNER_LOGO_START';
const UPDATE_PARTNER_LOGO_SUCCESS = 'UPDATE_PARTNER_LOGO_SUCCESS';
const UPDATE_PARTNER_LOGO_FAILED = 'UPDATE_PARTNER_LOGO_FAILED';
const UPDATE_PARTNER_LOGO_RESET = 'UPDATE_PARTNER_LOGO_RESET';

const DELETE_PARTNER_LOGO_START = 'DELETE_PARTNER_LOGO_START';
const DELETE_PARTNER_LOGO_SUCCESS = 'DELETE_PARTNER_LOGO_SUCCESS';
const DELETE_PARTNER_LOGO_FAILED = 'DELETE_PARTNER_LOGO_FAILED';
const DELETE_PARTNER_LOGO_RESET = 'DELETE_PARTNER_LOGO_RESET';

// Action Creators - About Us Page
const getAboutUsPageStart = (payload) => ({ type: GET_ABOUT_US_PAGE_START, payload });
const getAboutUsPageSuccess = (payload) => ({ type: GET_ABOUT_US_PAGE_SUCCESS, payload });
const getAboutUsPageFailed = (payload) => ({ type: GET_ABOUT_US_PAGE_FAILED, payload });
const getAboutUsPageReset = () => ({ type: GET_ABOUT_US_PAGE_RESET });

const updateAboutUsPageStart = (payload) => ({ type: UPDATE_ABOUT_US_PAGE_START, payload });
const updateAboutUsPageSuccess = (payload) => ({ type: UPDATE_ABOUT_US_PAGE_SUCCESS, payload });
const updateAboutUsPageFailed = (payload) => ({ type: UPDATE_ABOUT_US_PAGE_FAILED, payload });
const updateAboutUsPageReset = () => ({ type: UPDATE_ABOUT_US_PAGE_RESET });

// Action Creators - Partner Logos
const getPartnerLogosStart = (payload) => ({ type: GET_PARTNER_LOGOS_START, payload });
const getPartnerLogosSuccess = (payload) => ({ type: GET_PARTNER_LOGOS_SUCCESS, payload });
const getPartnerLogosFailed = (payload) => ({ type: GET_PARTNER_LOGOS_FAILED, payload });
const getPartnerLogosReset = () => ({ type: GET_PARTNER_LOGOS_RESET });

const getOnePartnerLogoStart = (payload) => ({ type: GET_ONE_PARTNER_LOGO_START, payload });
const getOnePartnerLogoSuccess = (payload) => ({ type: GET_ONE_PARTNER_LOGO_SUCCESS, payload });
const getOnePartnerLogoFailed = (payload) => ({ type: GET_ONE_PARTNER_LOGO_FAILED, payload });
const getOnePartnerLogoReset = () => ({ type: GET_ONE_PARTNER_LOGO_RESET });

const createPartnerLogoStart = (payload) => ({ type: CREATE_PARTNER_LOGO_START, payload });
const createPartnerLogoSuccess = (payload) => ({ type: CREATE_PARTNER_LOGO_SUCCESS, payload });
const createPartnerLogoFailed = (payload) => ({ type: CREATE_PARTNER_LOGO_FAILED, payload });
const createPartnerLogoReset = () => ({ type: CREATE_PARTNER_LOGO_RESET });

const updatePartnerLogoStart = (payload) => ({ type: UPDATE_PARTNER_LOGO_START, payload });
const updatePartnerLogoSuccess = (payload) => ({ type: UPDATE_PARTNER_LOGO_SUCCESS, payload });
const updatePartnerLogoFailed = (payload) => ({ type: UPDATE_PARTNER_LOGO_FAILED, payload });
const updatePartnerLogoReset = () => ({ type: UPDATE_PARTNER_LOGO_RESET });

const deletePartnerLogoStart = (payload) => ({ type: DELETE_PARTNER_LOGO_START, payload });
const deletePartnerLogoSuccess = (payload) => ({ type: DELETE_PARTNER_LOGO_SUCCESS, payload });
const deletePartnerLogoFailed = (payload) => ({ type: DELETE_PARTNER_LOGO_FAILED, payload });
const deletePartnerLogoReset = () => ({ type: DELETE_PARTNER_LOGO_RESET });

// Actions: Get About Us Page
export const getAboutUsPage = (payload) => {
  return async (dispatch) => {
    dispatch(
      getAboutUsPageStart({
        loading: true,
        success: false,
        data: null,
        error: false,
        errorMessage: null,
      })
    );

    try {
      const result = await ApiClient.get('aboutUs');
      if (result.data?.success) {
        const { aboutUs } = result.data.data;
        dispatch(
          getAboutUsPageSuccess({
            loading: false,
            success: true,
            data: { aboutUs },
            error: false,
            errorMessage: null,
          })
        );
      } else {
        dispatch(
          getAboutUsPageFailed({
            loading: false,
            success: false,
            data: null,
            error: true,
            errorMessage: result.data?.error || 'Internal Server Error!',
          })
        );
      }
    } catch (error) {
      dispatch(
        getAboutUsPageFailed({
          loading: false,
          success: false,
          data: null,
          error: true,
          errorMessage: error.message || 'Internal Server Error!',
        })
      );
    }
  };
};

// Actions: Clear Get About Us Page
export const clearGetAboutUsPage = () => getAboutUsPageReset();

// Actions: Update About Us Page
export const updateAboutUsPage = (payload, options) => {
  return async (dispatch) => {
    dispatch(
      updateAboutUsPageStart({
        loading: true,
        success: false,
        data: null,
        error: false,
        errorMessage: null,
      })
    );

    const { data } = payload;
    const { toastNotification, onSuccessMessage, onFailMessage } = options;

    try {
      const result = await ApiClient.put('aboutUs', data);
      if (result.data?.success) {
        const { aboutUs } = result.data.data;
        dispatch(
          updateAboutUsPageSuccess({
            loading: false,
            success: true,
            data: { aboutUs },
            error: false,
            errorMessage: null,
          })
        );
        toastNotification('success', onSuccessMessage);
      } else {
        dispatch(
          updateAboutUsPageFailed({
            loading: false,
            success: false,
            data: null,
            error: true,
            errorMessage: result.data?.error || 'Internal Server Error!',
          })
        );
        toastNotification('error', onFailMessage);
      }
    } catch (error) {
      dispatch(
        updateAboutUsPageFailed({
          loading: false,
          success: false,
          data: null,
          error: true,
          errorMessage: error.message || 'Internal Server Error!',
        })
      );
      toastNotification('error', onFailMessage);
    }
  };
};

// Actions: Clear Update About Us Page
export const clearUpdateAboutUsPage = () => updateAboutUsPageReset();

// Actions: Get Partner Logos
export const getPartnerLogos = (payload) => {
  return async (dispatch) => {
    dispatch(
      getPartnerLogosStart({
        loading: true,
        success: false,
        data: null,
        error: false,
        errorMessage: null,
      })
    );

    try {
      const { page, limit } = payload;
      const result = await ApiClient.get('partner-logos', {
        params: { page, limit },
      });
      if (result.data?.success) {
        const { logos, total, page: currentPage, limit: currentLimit } = result.data.data;
        dispatch(
          getPartnerLogosSuccess({
            loading: false,
            success: true,
            data: { logos, total, page: currentPage, limit: currentLimit },
            error: false,
            errorMessage: null,
          })
        );
      } else {
        dispatch(
          getPartnerLogosFailed({
            loading: false,
            success: false,
            data: null,
            error: true,
            errorMessage: result.data?.error || 'Internal Server Error!',
          })
        );
      }
    } catch (error) {
      dispatch(
        getPartnerLogosFailed({
          loading: false,
          success: false,
          data: null,
          error: true,
          errorMessage: error.message || 'Internal Server Error!',
        })
      );
    }
  };
};

// Actions: Clear Get Partner Logos
export const clearGetPartnerLogos = () => getPartnerLogosReset();

// Actions: Get One Partner Logo
export const getOnePartnerLogo = (payload) => {
  return async (dispatch) => {
    dispatch(
      getOnePartnerLogoStart({
        loading: true,
        success: false,
        data: null,
        error: false,
        errorMessage: null,
      })
    );

    try {
      const { logoId } = payload;
      const result = await ApiClient.get(`partner-logos/${logoId}`);
      if (result.data?.success) {
        const { logo } = result.data.data;
        dispatch(
          getOnePartnerLogoSuccess({
            loading: false,
            success: true,
            data: { logo },
            error: false,
            errorMessage: null,
          })
        );
      } else {
        dispatch(
          getOnePartnerLogoFailed({
            loading: false,
            success: false,
            data: null,
            error: true,
            errorMessage: result.data?.error || 'Internal Server Error!',
          })
        );
      }
    } catch (error) {
      dispatch(
        getOnePartnerLogoFailed({
          loading: false,
          success: false,
          data: null,
          error: true,
          errorMessage: error.message || 'Internal Server Error!',
        })
      );
    }
  };
};

// Actions: Clear Get One Partner Logo
export const clearGetOnePartnerLogo = () => getOnePartnerLogoReset();

// Actions: Upload Partner Logo (new API)
export const uploadPartnerLogo = (payload, options) => {
  return async (dispatch) => {
    dispatch(
      createPartnerLogoStart({
        loading: true,
        success: false,
        data: null,
        error: false,
        errorMessage: null,
      })
    );

    try {
      const { id, scale, logoFile } = payload;
      const formData = new FormData();
      formData.append('id', id);
      formData.append('scale', scale.toString());

      // Only append logo file if it exists (not null)
      if (logoFile) {
        formData.append('logo', logoFile);
      }

      const result = await ApiClient.post('aboutUs/partner-logo', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      if (result.data?.success) {
        const { partnerLogo, aboutUs } = result.data.data;
        dispatch(
          createPartnerLogoSuccess({
            loading: false,
            success: true,
            data: { partnerLogo, aboutUs },
            error: false,
            errorMessage: null,
          })
        );
        if (options?.toastNotification && options?.onSuccessMessage) {
          options.toastNotification('success', options.onSuccessMessage);
        }
      } else {
        dispatch(
          createPartnerLogoFailed({
            loading: false,
            success: false,
            data: null,
            error: true,
            errorMessage: result.data?.error || 'Internal Server Error!',
          })
        );
        if (options?.toastNotification && options?.onFailMessage) {
          options.toastNotification('error', options.onFailMessage);
        }
      }
    } catch (error) {
      dispatch(
        createPartnerLogoFailed({
          loading: false,
          success: false,
          data: null,
          error: true,
          errorMessage: error.message || 'Internal Server Error!',
        })
      );
      if (options?.toastNotification && options?.onFailMessage) {
        options.toastNotification('error', options.onFailMessage);
      }
    }
  };
};

// Actions: Create Partner Logo (legacy)
export const createPartnerLogo = (payload, options) => {
  return async (dispatch) => {
    dispatch(
      createPartnerLogoStart({
        loading: true,
        success: false,
        data: null,
        error: false,
        errorMessage: null,
      })
    );

    const { toastNotification, onSuccessMessage, onFailMessage } = options;

    try {
      const result = await ApiClient.post('partner-logos', payload);
      if (result.data?.success) {
        const { logo } = result.data.data;
        dispatch(
          createPartnerLogoSuccess({
            loading: false,
            success: true,
            data: { logo },
            error: false,
            errorMessage: null,
          })
        );
        toastNotification('success', onSuccessMessage);
      } else {
        dispatch(
          createPartnerLogoFailed({
            loading: false,
            success: false,
            data: null,
            error: true,
            errorMessage: result.data?.error || 'Internal Server Error!',
          })
        );
        toastNotification('error', onFailMessage);
      }
    } catch (error) {
      dispatch(
        createPartnerLogoFailed({
          loading: false,
          success: false,
          data: null,
          error: true,
          errorMessage: error.message || 'Internal Server Error!',
        })
      );
      toastNotification('error', onFailMessage);
    }
  };
};

// Actions: Clear Create Partner Logo
export const clearCreatePartnerLogo = () => createPartnerLogoReset();

// Actions: Update Partner Logo
export const updatePartnerLogo = (payload, options) => {
  return async (dispatch) => {
    dispatch(
      updatePartnerLogoStart({
        loading: true,
        success: false,
        data: null,
        error: false,
        errorMessage: null,
      })
    );

    const { logoId, data } = payload;
    const { toastNotification, onSuccessMessage, onFailMessage } = options;

    try {
      const result = await ApiClient.put(`partner-logos/${logoId}`, data);
      if (result.data?.success) {
        const { logo } = result.data.data;
        dispatch(
          updatePartnerLogoSuccess({
            loading: false,
            success: true,
            data: { logo },
            error: false,
            errorMessage: null,
          })
        );
        toastNotification('success', onSuccessMessage);
      } else {
        dispatch(
          updatePartnerLogoFailed({
            loading: false,
            success: false,
            data: null,
            error: true,
            errorMessage: result.data?.error || 'Internal Server Error!',
          })
        );
        toastNotification('error', onFailMessage);
      }
    } catch (error) {
      dispatch(
        updatePartnerLogoFailed({
          loading: false,
          success: false,
          data: null,
          error: true,
          errorMessage: error.message || 'Internal Server Error!',
        })
      );
      toastNotification('error', onFailMessage);
    }
  };
};

// Actions: Clear Update Partner Logo
export const clearUpdatePartnerLogo = () => updatePartnerLogoReset();

// Actions: Delete Partner Logo from AboutUs (new API)
export const deleteAboutUsPartnerLogo = (payload, options) => {
  return async (dispatch) => {
    dispatch(
      deletePartnerLogoStart({
        loading: true,
        success: false,
        data: null,
        error: false,
        errorMessage: null,
      })
    );

    try {
      const { logoId } = payload;
      const result = await ApiClient.delete(`aboutUs/partner-logo/${logoId}`);

      if (result.data?.success) {
        const { aboutUs } = result.data.data;
        dispatch(
          deletePartnerLogoSuccess({
            loading: false,
            success: true,
            data: { aboutUs },
            error: false,
            errorMessage: null,
          })
        );
        if (options?.toastNotification && options?.onSuccessMessage) {
          options.toastNotification('success', options.onSuccessMessage);
        }
      } else {
        dispatch(
          deletePartnerLogoFailed({
            loading: false,
            success: false,
            data: null,
            error: true,
            errorMessage: result.data?.error || 'Internal Server Error!',
          })
        );
        if (options?.toastNotification && options?.onFailMessage) {
          options.toastNotification('error', options.onFailMessage);
        }
      }
    } catch (error) {
      dispatch(
        deletePartnerLogoFailed({
          loading: false,
          success: false,
          data: null,
          error: true,
          errorMessage: error.message || 'Internal Server Error!',
        })
      );
      if (options?.toastNotification && options?.onFailMessage) {
        options.toastNotification('error', options.onFailMessage);
      }
    }
  };
};

// Actions: Delete Partner Logo (legacy)
export const deletePartnerLogo = (payload, options) => {
  return async (dispatch) => {
    dispatch(
      deletePartnerLogoStart({
        loading: true,
        success: false,
        data: null,
        error: false,
        errorMessage: null,
      })
    );

    const { logoId } = payload;
    const { toastNotification, onSuccessMessage, onFailMessage } = options;

    try {
      const result = await ApiClient.delete(`partner-logos/${logoId}`);
      if (result.data?.success) {
        dispatch(
          deletePartnerLogoSuccess({
            loading: false,
            success: true,
            data: null,
            error: false,
            errorMessage: null,
          })
        );
        toastNotification('success', onSuccessMessage);
      } else {
        dispatch(
          deletePartnerLogoFailed({
            loading: false,
            success: false,
            data: null,
            error: true,
            errorMessage: result.data?.error || 'Internal Server Error!',
          })
        );
        toastNotification('error', onFailMessage);
      }
    } catch (error) {
      dispatch(
        deletePartnerLogoFailed({
          loading: false,
          success: false,
          data: null,
          error: true,
          errorMessage: error.message || 'Internal Server Error!',
        })
      );
      toastNotification('error', onFailMessage);
    }
  };
};

// Actions: Clear Delete Partner Logo
export const clearDeletePartnerLogo = () => deletePartnerLogoReset();
